import type { ActionTakenFeedbackData } from 'src/shared/services/concierge-api.service';

// Mirrors the backend allow-list for ticket_comment_sent feedback
// (gotidy: Samantha::ActionTakenUserFeedback ... TicketCommentSent::ELIGIBLE_USER_TYPES).
// Only AI replies and human concierge agents can be rated; customer and
// homekeeper comments are rejected server-side.
export const FEEDBACK_ELIGIBLE_USER_TYPES = [
  'AiTask',
  'AiFrontendAgent',
  'ConciergeUser',
] as const;

export function isCommentFeedbackEligible(userType?: string): boolean {
  return !!userType && (FEEDBACK_ELIGIBLE_USER_TYPES as readonly string[]).includes(userType);
}

export function buildCommentFeedbackPayload(params: {
  commentId: number;
  conciergeItemId: number;
  type: 'positive' | 'negative';
  text?: string;
}): ActionTakenFeedbackData {
  const data: ActionTakenFeedbackData = {
    action_taken_key: 'ticket_comment_sent',
    action_object_id: params.commentId,
    feedback_status: params.type === 'positive' ? 'approved' : 'rejected',
    metadata: { concierge_item_id: params.conciergeItemId },
  };
  const trimmed = params.text?.trim();
  if (trimmed) {
    data.feedback_text = trimmed;
  }
  return data;
}
